import React from 'react';

export interface IUserSessionContext {
    showSessionExpirationWarning : boolean;
    setShowSessionExpirationWarning : Function;
}


const defaultContextValue : IUserSessionContext= {
    showSessionExpirationWarning: false,
    setShowSessionExpirationWarning: () => {}
};

const UserSessionContext = React.createContext<IUserSessionContext>(defaultContextValue);

export default UserSessionContext;